import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

interface ICollapsedProps {
  isExpanded?: boolean;
}

interface IRowProps {
  isSelected?: boolean;
  inactive?: boolean;
}

interface IAllocationCountProps {
  isAllocated?: boolean;
  isInvalid?: boolean;
}

interface IAllocationDotProps {
  large?: boolean;
  isInvalid?: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
`;

export const TextTruncate = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HeaderLabel = styled(TextTruncate)`
  font-weight: 500;
`;

export const Label = styled(TextTruncate)`
  padding-left: 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  letter-spacing: 0.3px;
  color: ${colors.grey7};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  letter-spacing: 0.3px;
  color: ${colors.grey7};
`;

export const IconWrapper = styled.div<ICollapsedProps>`
  display: flex;
  cursor: pointer;
  transition: 0.15s transform ease-in-out;
  height: 20px;
  width: 20px;

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      transform: rotate(90deg);
    `};
`;

export const Cell = styled.div`
  display: flex;
  font-size: 13px;
  letter-spacing: 0.3px;
  line-height: 20px;
  color: ${colors.grey8};
  overflow: hidden;
`;

export const CellNumber = styled(Cell)`
  justify-content: flex-end;
`;

export const CellIcon = styled(CellNumber)`
  align-items: center;
`;

export const GridRow = styled.div<IRowProps>`
  padding: 10px;
  display: grid;
  grid-template-columns: minmax(20px, 20px) 2fr minmax(min-content, 1fr) minmax(
      45px,
      min-content
    );
  grid-gap: 10px;
  width: 100%;
  cursor: default;

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: ${colors.white};
    `};

  ${({ inactive }) =>
    inactive &&
    css`
      ${CellNumber} {
        color: ${colors.grey5};
      }
    `};
`;

export const GridRowPlain = styled(GridRow)`
  grid-template-columns: 2fr minmax(min-content, 1fr) minmax(45px, min-content);
`;

export const AllocationCount = styled.div<IAllocationCountProps>`
  color: ${({ isAllocated, isInvalid }) =>
    isInvalid ? colors.red1 : isAllocated ? colors.green2 : colors.grey5};
`;

export const AllocationDot = styled.div<IAllocationDotProps>`
  height: 6px;
  width: 6px;
  margin-right: 8px;
  background-color: ${({ isInvalid }) =>
    isInvalid ? colors.red1 : colors.green1};
  border-radius: 50%;
  display: inline-block;

  ${({ large }) =>
    large &&
    css`
      width: 10px;
      height: 10px;
      margin-right: 6px;
    `};
`;
